import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import FlexRow from '../../../../molecules/FlexRow'
import DatasourceGroup from './DatasourceGroup'

function DatasourceLayout ({ items }) {
  const groupedItems = useMemo(() => {
    const grouped = (items || []).reduce((acc, item) => {
      if (!(item.namespace.code in acc)) {
        acc[item.namespace.code] = []
      }
      acc[item.namespace.code].push(item)

      return acc
    }, {})

    return Object.entries(grouped).map(([code, items]) => ({
      code,
      name: items.at(0).namespace.displayName,
      items
    }))
  }, [items])

  return (
    <FlexRow>
      {groupedItems.map(group => (
        <DatasourceGroup key={group.code} groupName={group.name} groupItems={group.items} />
      ))}
    </FlexRow>
  )
}

DatasourceLayout.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    catalogDatasourceId: PropTypes.number,
    code: PropTypes.string,
    displayName: PropTypes.string,
    imageUrl: PropTypes.string,
    namespace: PropTypes.shape({
      displayName: PropTypes.string
    })
  }))
}

export default DatasourceLayout
